import React, { useEffect, useState } from 'react';
import { Loader } from '../../../../../../Common';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import { CustomCard } from '../Comman';
import { useDispatch, useSelector } from 'react-redux';
import { GET_BENEFIT_AND_BENEFIT_GROUP } from '../../../../../../../store/actions';
import cogoToast from 'cogo-toast';
import { ChevronLeft } from 'react-feather';

const SelectBenefit = ({ state, setState, setFormCount }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { getBenefit } = useSelector((state: any) => ({
    getBenefit: state.GetBenefitAndBenefitGroup?.data?.results?.benefit_types,
  }));

  const [selectedBenefit, setSelectedBenefit] = useState(null);

  console.log('state?.benefit', selectedBenefit);

  useEffect(() => {
    if (!state?.benefit) {
      dispatch({
        type: GET_BENEFIT_AND_BENEFIT_GROUP,
        payload: {
          data: {
            clientId: state?.client?.id,
            projectId: state?.project?.id,
          },
          urlParams: {
            pageSize: 10,
            pageIndex: 1,
          },
        },
      });
    }
    if (state?.benefit) {
      setSelectedBenefit(state.benefit);
    }
  }, [state]);

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const handleSubmit = () => {
    if (!selectedBenefit) {
      cogoToast.error('Please select benefit first');
      return;
    }
    setFormCount((prev: number) => prev + 1);
  };

  const routeHandler = item => {
    setSelectedBenefit(item);
    setState(prev => ({ ...prev, benefit: item }));
    setFormCount((prev: number) => prev + 1);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Program Onboarding`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Benefit List']}
            />
          </div>
        </div>

        <Card>
          <CardHeader>
            <h5 className="m-0 fw-semibold">Select Benefit</h5>
          </CardHeader>
          <CardBody className="pb-5">
            <Row className="d-flex mx-1">
              {getBenefit?.map((benefit: any, index: number) => {
                const isSelected = selectedBenefit?.name === benefit.name;
                return <CustomCard clientName={benefit?.name} country={''} key={index} selected={isSelected} onClick={() => routeHandler(benefit)} />;
              })}
            </Row>
          </CardBody>
        </Card>
        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount((prev: number) => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default SelectBenefit;
